import { exportReportPdfFromExcelBlob } from "./exportReportPdfFromExcelBlob";

/** Column order matches backend Customer MIS Pallet Excel export. */
export const CUSTOMER_MIS_PALLET_EXPORT_HEADERS = [
  "Customer",
  "SKU",
  "SKU Name",
  "Received Units",
  "Received Pallet Equivalent",
  "Current Units Stock",
  "Current Pallet Stock",
  "Dispatched Units",
  "Dispatched Pallet Equivalent",
  "Conversion Qty Per Pallet",
  "Weight Per Pallet",
];

export async function exportCustomerMisPalletReportPdfFromExcelBlob(
  excelBlob,
  filename
) {
  return exportReportPdfFromExcelBlob(
    excelBlob,
    filename,
    CUSTOMER_MIS_PALLET_EXPORT_HEADERS
  );
}
